
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0zm0 5C16.193 5 5 16.193 5 30s11.193 25 25 25 25-11.193 25-25S43.807 5 30 5zm15.672 13.246c.977.977.996 2.544.04 3.5L27.868 41.84a2.526 2.526 0 01-.133.123.87.87 0 01-.06.065c-.977.978-2.12 1.101-3.074.146l-8.896-7.388c-.955-.955-.936-2.522.042-3.5.977-.977 2.544-.996 3.5-.04l6.577 5.409 16.349-18.45c.955-.956 2.522-.937 3.5.04z","clip-rule":"evenodd"}})])
          )
        }
      }
    